import type { ScrollMeta } from '../common/types';

export const getIsScrollingX = (state: ScrollMeta) => state.isScrollingX;

export const getIsScrollingY = (state: ScrollMeta) => state.isScrollingY;

export const getIsScrollToTop = (state: ScrollMeta) => state.positions.top === 0;
